import React from 'react'

const Icon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <path
        d='M3.4165 16.5833V11H4.49984V14.7339L14.7338 4.49996H10.9998V3.41663H16.5832V8.99996H15.4998V5.266L5.26588 15.5H8.99984V16.5833H3.4165Z'
        fill='#686867'
      />
    </svg>
  )
}

export default Icon
